var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 10.8333C10.7188 10.8333 11.1665 10.4602 11.1665 9.99998C11.1665 9.53974 10.7188 9.16665 10.1665 9.16665C9.61422 9.16665 9.1665 9.53974 9.1665 9.99998C9.1665 10.4602 9.61422 10.8333 10.1665 10.8333Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 4.99998C10.7188 4.99998 11.1665 4.62688 11.1665 4.16665C11.1665 3.70641 10.7188 3.33331 10.1665 3.33331C9.61422 3.33331 9.1665 3.70641 9.1665 4.16665C9.1665 4.62688 9.61422 4.99998 10.1665 4.99998Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 16.6666C10.7188 16.6666 11.1665 16.2936 11.1665 15.8333C11.1665 15.3731 10.7188 15 10.1665 15C9.61422 15 9.1665 15.3731 9.1665 15.8333C9.1665 16.2936 9.61422 16.6666 10.1665 16.6666Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.5168e7216a88348aebf68db474e2aa40.svg";
export { ForwardRef as ReactComponent };